import { postJsMessage } from '../../bridge';
import API from '../../api';
import { isAvailable } from '../utils';
import { NativeAPIResponseMessage } from '@zoom/hybrid-jsbridge';
import { PostMessageOption } from 'types/index';

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * auth.getNak
 *
 * [PLATFORM]
 * mac        6.1.10+
 * windows    6.1.10+
 * linux      6.1.10+
 * ios        6.1.10+
 * android    6.1.10+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export function getNak(
  param: GetNakOption = {},
  options?: PostMessageOption
): Promise<NativeAPIResponseMessage<NakResponse>> {
  return isAvailable('auth.getNak').then(() => {
    return postJsMessage<GetNakOption, NakResponse>(API.getNak, param, options);
  });
}

export type GetNakOption = {
  pms?: string;
  src?: string;
};
export type NakResponse = {
  nak: string;
};

/** * -------------------------------------------------- API Doc --------------------------------------------------
 * [API]
 * auth.getZak
 *
 * [PLATFORM]
 * mac        6.2.5+
 * windows    6.2.5+
 * linux      6.2.5+
 * ios        6.2.5+
 * android    6.2.5+
 *
 * -------------------------------------------------- API Doc --------------------------------------------------*/
export function getZak(
  options?: PostMessageOption
): Promise<NativeAPIResponseMessage<ZakResponse>> {
  return isAvailable('auth.getZak').then(() => {
    return postJsMessage(API.getZak, {}, options);
  });
}

export type ZakResponse = {
  zak: string;
  expires: string;
};

export default {
  getZak,
  getNak,
};
